import React from "react"

function QrCode(props) {
  return (
    <div className="col mt-2 nopadding border-1">
      {props.qr !== undefined && props.qr !== null && props.qr !== "" ? (
        <img src={props.qr} alt={props.qr} className="w-100 h-100" />
      ) : (
          ""
        )}
    </div>
  )
}

export default QrCode


// WEBPACK FOOTER //
// ./src/components/Common/QrCode.js